import React from 'react';
import { Flex } from '@smarterservices/smarter-ui';
import { BlockComponentProps, SectionBlock as SectionBlockType } from '../../types';
import BlockRenderer from '../../BlockRenderer';

/**
 * SectionBlock component renders a container for other block elements
 * 
 * @param {BlockComponentProps<SectionBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered section
 */
export const SectionBlock = ({ block }: BlockComponentProps<SectionBlockType>) => {
  return (
    <Flex as="div" direction="column" margin={block.margin || "none"}>
      {block.elements && block.elements.length > 0 && <BlockRenderer blocks={block.elements} />}
    </Flex>
  );
};

export default SectionBlock;
